/**
 * Present a dialog asking the user to confirm their resignation
 * from a given role. If the user confirms, the role will be
 * deleted and the user will no longer have that role.
 */
import _ from 'underscore';
import Handlebars from 'handlebars';
import Radio from 'backbone.radio';
import ConfirmationDialog from '@/views/dialogs/confirmation';

var globalCh = Radio.channel('global');

var body_html = '<p>By resigning, you will lose any '
    + 'privileges associated with the {{role_name}} role on the '
    + '<b>{{target_name}}</b> account.</p>'
;
var title_tmpl = Handlebars.compile(
    'Resigning from {{role_name}} Role'
);

/**
 * Function to add more information based on the relationship
 * between target and rolee implied by the role, and inform
 * the user of possible consequences
 */
function add_caveats(initial_text, roles) {
    var permissions = roles.map(function(r) {
        return r.get('permissions');
    });
    permissions = _.flatten(permissions);
    permissions = _.uniq(permissions);
    var modified_text = initial_text;
    _({
        'view_development_devices': '<p>If you have development devices '
            + 'in device groups belonging to <b>{{target_name}},</b> '
            + 'you may not be able to retrieve them.</p>'
    }).each(function(blurb, permission) {
        permissions.forEach(function(granted_permission) {
            if (granted_permission == permission) {
                modified_text += '\n' + blurb;
            }
        });
    });
    return modified_text;
}
function show_resign_from_role_dialog(proxy) {
    
    function show_dialog() {
        var target = proxy.get('target');
        var roles = proxy.get('grants').map(function(g) {
            return g.rel.get('role');
        });
        var role_name = roles.map(function(r) {
            return r.get('name');
        }).join(', ');
        
        var body_tmpl = Handlebars.compile(
            add_caveats(body_html, roles)
        );

        var context = {
            role_name: role_name,
            target_name: target.get('name')
        };

        function callback(){
            proxy.destroy().then(()=>{
                this.closeDialog();
            }).catch((e)=>{
                if (e.responseJSON && e.responseJSON.errors.length) {
                    const error = e.responseJSON.errors[0];
                    this.showAlert('alert-danger',
                        `${error.code}: ${error.detail} 
                        ${error.meta.devices ? "Devices: " + error.meta.devices.join(', ') : ""}`);
                }
            });
        }

        var dialog = new ConfirmationDialog({
            callback: callback,
            message: {
                title: title_tmpl(context),
                body: body_tmpl(context),
                primary_action: 'Resign from Role'
            },
            waitToClose: true,
        });

        globalCh.request('showDialog', dialog);
    }

    show_dialog();
}
export default show_resign_from_role_dialog;

